import axiosInstance from './index';
export function searchComorbidity(params) {
    return axiosInstance({
        url: '/search/searchComorbidity',
        method: 'get',
        params,
    })
}
// /searchComorbidity  (参数:String name,String comorbidityName,String snp,String ppi,String gene,String pathway)